import { render, staticRenderFns } from "./Exclamation.vue?vue&type=template&id=2a43b920&scoped=true&"
import script from "./Exclamation.vue?vue&type=script&lang=js&"
export * from "./Exclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43b920",
  null
  
)

export default component.exports